import { render } from "./config.vue?vue&type=template&id=58a37d1a&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"

import "./config.vue?vue&type=style&index=0&id=58a37d1a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-58a37d1a"

export default script